import { FC } from 'react'
import { FormSearchArtist } from '../SearchArtist'
import { FormSearchProduct } from '../SearchProduct'
import { FormCategorySelect } from '../SearchCategory'
import { FormAdvertiserSelect } from '../SearchAdvertiser'
import { FormMediaBuyerSelect } from '../SearchMediaBuyer'
import { InfoField } from '../InfoField'

export const OtherGenerateCampaignForm: FC = () => (
  <>
    <FormAdvertiserSelect />
    <FormMediaBuyerSelect />
    <FormCategorySelect />
    <FormSearchArtist />
    <FormSearchProduct />
    <InfoField />
  </>
)
